'use client'

import { Button, Icon } from '@vinted/web-ui'
import { ChevronLeft16, ChevronRight16 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  direction: 'prev' | 'next'
  isVisible: boolean
  onClick: () => void
  testId: string
}

export const NavigationButton = ({ direction, isVisible, onClick, testId }: Props) => {
  const translate = useTranslate('a11y.actions')

  if (!isVisible) {
    return <div />
  }

  return (
    <Button
      styling={Button.Styling.Flat}
      size={Button.Size.Small}
      iconName={direction === 'prev' ? ChevronLeft16 : ChevronRight16}
      iconColor={Icon.Color.GreyscaleLevel1}
      inline
      onClick={onClick}
      testId={testId}
      aria-label={direction === 'prev' ? translate('move_left') : translate('move_right')}
    />
  )
}
